<template>
  <div class="main-page findLawyer">
    <Menu title="律师查询"
          :home="true">
      <template slot="left-link">
        <a href="javascript:;"
           @click="goPrevious()"></a>
      </template>
    </Menu>
    <div class="container-flex lawyer-container">
      <div class="lawyer-search-panel  ">

        <div class="input-panel">
          <input type="text"
                 v-model="searchForm.mc"
                 placeholder="律师中文名/执业证号">
          <button class="flex justify-center items-center flex-shrink-0 text-lg"
                  @click="getSearch"> <img src="https://qiniu.laway.cn/yn/2025/02/08/f8648f40e5c411ef99f8b4055d0b07be.svg"
                 class="mr-[4px]"> 搜索</button>
        </div>
        <div class="search-params">
          <div class="hts">高级检索</div>
          <div class="params-item">
            <div class="params-item-title">所在地区：</div>
            <div class="params-item-content">
              <div @click="searchForm.city = '';searchForm.code=''"
                   :class="['radio-item  ',{active:!searchForm.city}]">
                <input type="radio">
                不限
              </div>
              <div @click="searchForm.city = key;searchForm.code=''"
                   :class="['radio-item  ',{active:searchForm.city==key}]"
                   v-for="(city, key) in arealist"
                   :key="'key-c' + key">
                <input type="radio"
                       v-model="searchForm.code">
                {{city.alias}}
              </div>
            </div>
          </div>
          <div class="params-item"
               v-if="arealist[searchForm.city]">
            <div class="params-item-title">所在区县：</div>
            <div class="params-item-content">
              <div @click="searchForm.code=''"
                   :class="['radio-item  ',{active:!searchForm.code}]">
                <input type="radio"
                       v-model="searchForm.code">
                不限
              </div>
              <div @click="searchForm.code = key"
                   :class="['radio-item  ',{active:searchForm.code==key}]"
                   v-for="(v, key) in arealist[searchForm.city].children"
                   :key="'key-c' + key">
                <input type="radio"
                       v-model="searchForm.code">
                {{v.alias}}
              </div>
            </div>
          </div>

          <div class="params-item">
            <div class="params-item-title">性别：</div>
            <div class="params-item-content">
              <div @click="searchForm.xb=''"
                   :class="['radio-item ',{active:!searchForm.xb}]">
                <input type="radio"
                       value="">
                不限
              </div>
              <div @click="searchForm.xb=v.id"
                   v-for="(v, key) in lawyerDefine.sex"
                   :key="'key-c' + key"
                   :class="['radio-item ',{active:searchForm.xb==v.id}]">
                <input type="radio"
                       :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
          <div class="params-item">
            <div class="params-item-title">执业类型：</div>
            <div class="params-item-content">
              <div @click="searchForm.zylb=''"
                   :class="['radio-item ',{active:!searchForm.zylb}]">
                <input type="radio"
                       value="">
                不限
              </div>
              <div @click="searchForm.zylb=v.id"
                   v-for="(v, key) in lawyerDefine.zylb"
                   :key="'key-c' + key"
                   :class="['radio-item ',{active:searchForm.zylb==v.id}]">
                <input type="radio"
                       :value="v.id">
                {{ v.name }}
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="lawyer-list-panel">

        <div class="lawyer-list ">
          <div class="item"
               v-for="(item, index) in list"
               :key="'res'+ index"
               @click="handleShowLawyer(item)">
            <img :src="item.zp ||'/img/ui/lawyer_avatar.png'"
                 alt="">

            <div class="content">
              <div class="name">
                {{item.xm}}
              </div>
              <div class="skill">
                执业类别：{{item.zylb}}
              </div>
              <div>
                执业证号：{{item.zyzh || '-'}}<br> 电话：{{item.lxfs || '-'}}
              </div>
            </div>

          </div>
          <div v-if="loadOver &&  list.length &&pageSize>page"
               class="more-btn">

            <button @click="getMore">加载更多</button>
          </div>
          <div v-if="loadOver&& !list.length"
               class="empty-info">
            <img src="https://qiniu.laway.cn/yn/2020/11/10/e0a5a0ac22fe11eb8cd1b4055d0b07be.png"
                 class="mx-auto"
                 alt="">
            <p>没有搜索到~</p>
          </div>
        </div>

      </div>

    </div>
    <div class="lawyer-about"
         v-if="showLawyer">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="lawyer">
              <div class="content">
                <div v-if="currentlawyer.zp"
                     class="imgs"
                     :style="'background-image:url('+currentlawyer.zp+')'"></div>
                <div v-else
                     class="imgs"
                     style="background-image:url('/img/ui/lawyer_avatar.png')"></div>
                <div class="intro">
                  <strong class="name">{{ currentlawyer.xm }}</strong>

                  <div class="lawfir">{{ currentlawyer.firm_name || '暂无' }}</div>
                </div>
                <div class="sc">
                  <ul>
                    <li>执业证号：{{ currentlawyer.zyzh }}</li>
                    <li style="width:100%">执业年限：-</li>
                    <li style="width:100%">联系电话：{{currentlawyer.lxfs||'-'}}</li>
                    <li style="width:100%">执业类别：{{ currentlawyer.zylb || '-' }}</li>
                    <li style="width:100%">执业机构：{{ currentlawyer.firm_name || '-' }}</li>
                    <li style="width:100%">工作地址：{{ currentlawyer.firm_address || '-' }}</li>
                    <li style="width:100%">擅长业务：{{ currentlawyer.adept || '-' }}</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import Menu from '@/components/Menu'
import { LAWYER_INQUIRE } from '@/datas/constants/statistics.js'
export default {
  data () {
    return {
      step: 0,
      showLawyer: false,
      currentlawyer: '',
      searchForm: {
        city: '',
        code: '',
        xb: '',
        zylb: '',
        mc: '',
      },
      lawyerDefine: '',
      page: 1,
      pageSize: 0,
      list: [],
      loadOver: false
    }
  },
  components: {
    Menu,
  },
  computed: {

    point () {
      return this.$store.state.device.point
    },
    arealist () {
      return this.$store.state.device.area
    },
    curType () {
      return 1
    }

  },
  watch: {
    searchForm: {
      deep: true,
      handler (val) {
        this.searchForm.mc = this.searchForm.mc.trim()
      }
    },
  },
  async mounted () {
    const { mc, xb, zylb, code, city } = this.$route.query
    this.searchForm = {
      ...this.searchForm,
      mc, xb, zylb, code, city
    }
    this.getDefine()
    this.getList()
    this.$root.getStatistics(LAWYER_INQUIRE)
  },
  methods: {
    async getDefine () {
      const data = await this.$api.getLawyerDefine()
      this.lawyerDefine = data
    },
    getSearch () {
      if (mc.length < 2) {
        this.$alert(mc.length ? '至少输入两位关键字' : '请输入律师中文名/执业证号')
        return
      }
      this.page = 1
      this.getList()
    },
    async getList () {
      let { mc, code, city, zylb, xb } = this.searchForm
      if (mc.length < 2) return
      const result = await this.$api.lsLawyer({
        params: {
          mc,
          page: this.page,
          code: code || city,
          xb,
          zylb,
          per_page: 10
        }
      })
      this.list = this.page > 1 ? [...this.list, ...result.data] : result.data
      this.pageSize = result.num_pages
      this.loadOver = true
    },
    getMore () {
      this.page++
      this.getList()
    },
    goPrevious () {
      !this.showLawyer ? this.$router.go(-1) : this.showLawyer = false
    },
    handleShowLawyer (item) {
      this.showLawyer = true
      this.currentlawyer = item
    },



  }
}
</script>

<style lang="stylus" scoped>
.findLawyer
  .lawyer-container
    display flex
    overflow hidden
    .lawyer-search-panel
      width 25%
      padding 0.2rem
      background #fff
      height 100%
      .input-panel
        position relative
        margin-top 0.1rem
        border-radius 0.1rem
        overflow hidden
        display flex
        background #fff
        border 1px solid #378bf8
        input
          font-size 0.18rem
          padding 0 0.2rem
          flex 1
          border 0
        input:-moz-placeholder, input::-moz-placeholder
          color #999
          opacity 1
        input:-ms-input-placeholder
          color #999
        input::-webkit-input-placeholder
          color #999
        button
          width 1rem
          height 0.45rem
          font-size 0.2rem
          color #fff
          background-color #2a69e0
      .search-params
        padding-top 0.2rem
        .hts
          font-size 0.2rem
          font-weight bold
          letter-spacing 1px
          color #333
          margin-bottom 0.1rem
        .params-item
          display flex
          align-items baseline
          margin-bottom 0.1rem
          .params-item-title
            font-size 0.18rem
            width 0.9rem
            flex-shrink 0
            text-align right
          .params-item-content
            flex 1
            display flex
            font-size 0.22rem
            flex-wrap wrap
            padding-left 0.1rem
      .radio-item
        letter-spacing 1px
        margin-bottom 0.1rem
        font-size 0.18rem
        margin-right 0.2rem
        input
          width 12px
          height 12px
          cursor pointer
          margin-right 2px
          border-radius 2px
          border solid 1px #e6e6e6
        &.active
          color #f29530
          input
            position relative
            border-color #f29530
            &::after
              content ''
              position absolute
              top -1px
              left 1px
              width 5px
              height 8px
              border-left solid #f29530 1px
              border-top solid #f29530 1px
              transform rotate(225deg)
    .lawyer-list-panel
      flex 1
      overflow hidden
      .lawyer-list
        max-height 100%
        overflow-y auto
        display flex
        justify-content space-between
        flex-wrap wrap
        padding 0 0.4rem 0 0.4rem
        .item
          width 49%
          background #fff
          border-radius 0.05rem
          border 0.01rem solid #eee
          padding 0.25rem
          display flex
          margin-bottom 0.3rem
          font-size 0.16rem
          color #808080
          &:active
            background #f7f7f7
          img
            width 1rem
            margin-right 0.2rem
          .name
            font-size 0.24rem
            color #333
            margin 0.15rem 0 0.1rem
      .more-btn
        width 100%
        padding 0 0 0.2rem
        text-align center
        button
          width 2rem
          background #fff
          font-size 0.2rem
          padding 0.1rem
          border-radius 0.1rem
          color #2a69e0
      .empty-info
        text-align center
        color #fff
        width 100%
        padding-top 1rem
        img
          margin-bottom 0.3rem
  .lawyer-about
    position fixed
    left 0
    right 0
    bottom 0
    top 1.2rem
    overflow-y scroll
    z-index 2100
    background #ddd
    .lawyer
      padding-bottom 1.2rem
      .btn-zxls
        display flex
        justify-content center
        align-items center
        height 0.6rem
        font-size 0.24rem
        margin 40px 20% 0
      .content
        margin 1rem 0 0.1rem
        border-radius 0.05rem
        position relative
        border-bottom 0.01rem solid #ddd
        .imgs
          position absolute
          top -0.75rem
          left 50%
          margin-left -0.75rem
          width 1.5rem
          height 1.5rem
          border 0.03rem solid #fff
          border-radius 50%
          background-size cover
          background-color #fff
          background-position center 0
          box-shadow 0 0.03rem 0.05rem rgba(0, 0, 0, 0.3)
        .sc
          background #fff
          padding 0.35rem
          border-radius 0 0 0.05rem 0.05rem
          color #808080
          font-size 0.2rem
          ul
            display flex
            flex-wrap wrap
            li
              width 50%
              padding-bottom 0.2rem
        .tel
          display flex
          justify-content center
          align-items center
          padding 0.15rem
          border-radius 0 0 0.05rem 0.05rem
          color #999
          .icon
            color #4caf50
      .body
        background #fff
        padding 0.25rem
        min-height 0.7rem
        color #555
        border-radius 0.05rem
        border-bottom 0.01rem solid #ddd
        .ht
          border-bottom 0.01rem solid #eee
          padding-bottom 0.1rem
          margin-bottom 0.1rem
          font-size 0.24rem
          font-weight bold
        .detail
          padding 0.3rem
          font-size 0.18rem
      .intro
        padding 1.05rem 0.15rem 0.5rem
        border-radius 0.05rem 0.05rem 0 0
        background #1488cc
        /* fallback for old browsers */
        background -webkit-linear-gradient(to right, #2b32b2, #1488cc)
        /* Chrome 10-25, Safari 5.1-6 */
        background linear-gradient(to right, #2b32b2, #1488cc)
        /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        .name
          display block
          text-align center
          color #fff
          font-size 0.36rem
          margin-bottom 0.05rem
        .lawfir
          padding-top 0.1rem
          color #fff
          opacity 0.6
          text-align center
          font-size 0.18rem
</style>
